import React, { useState } from 'react';
import styles from "./GraphInterval.module.css"
import close from "../../../../../assets/Close.svg";


const GraphInterval = ({ setIsXInterval, xInterval, setXInterval }) => {

    const [inputXInterval , setInputXInterval] = useState("")

    const handleSave = () => {
        setXInterval(inputXInterval);
        setIsXInterval(false);
    }
    

    return (
        <div className={styles.model}>
            <div className={styles.container}>

                <button className={styles.closeBtn} >
                    <img src={close} alt="close" srcset="" onClick={() => setIsXInterval(false)} />
                </button>

                <h1 className={styles.title}>Graph Interval</h1>

                <div className={styles.row}>
                    <label className={styles.label} >X Interval :</label>
                    <input type="text" placeholder="EX : 1M OR 1H" onChange={(e) => setInputXInterval(e.target.value)} className={styles.input} defaultValue={xInterval} />

                </div>

                <button className={styles.saveBtn} onClick={handleSave}>
                    save
                </button>
            </div>

        </div>
    )
}

export default GraphInterval